// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"161":"08e185b69f555321","246":"9f9ead799bb4ffca","356":"7d1b67e533f76dc6","379":"ae3de1cc52846041","484":"33de4064fc5076e2","538":"d288b978e330e581","539":"7724a50100a03cb4","604":"3abec64d6d0f088c","729":"1f35c3f338aa1012","886":"f5c48b5b485e0920"}[chunkId] + ".js";
};